export const OportunityIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    {...props}
  >
    <rect width={40} height={40} x={4} y={4} fill="#D1FADF" rx={20} />
    <path
      fill="#333"
      d="M24 16.375c-.56 0-1.08.143-1.563.43a3.101 3.101 0 0 0-1.152 1.133 3.112 3.112 0 0 0-.41 1.562v.625h-3.086l-.039.586-.664 11.914h13.828l-.664-11.914-.04-.586h-3.085V19.5c0-.56-.143-1.08-.43-1.563a2.958 2.958 0 0 0-1.133-1.132 3.003 3.003 0 0 0-1.562-.43Zm0 1.25c.52 0 .963.182 1.328.547.365.364.547.807.547 1.328v.625h-3.75V19.5c0-.52.182-.963.547-1.328A1.808 1.808 0 0 1 24 17.625Zm-5.04 3.75h1.915v1.875h1.25v-1.875h3.75v1.875h1.25v-1.875h1.914l.547 10H18.414l.547-10Z"
    />
    <rect
      width={40}
      height={40}
      x={4}
      y={4}
      stroke="#ECFDF3"
      strokeWidth={8}
      rx={20}
    />
  </svg>
);
